import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contactListSchema } from '../../../common/validations/contractContacts'

import { get } from 'api/apiClient'

const params = (contractUUID: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractUUID}/contacts`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${contractUUID}/contacts`,
      contactListSchema
    ),
})

export const useAPIGetContractContacts = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractContactsSuspense = (contractUUID: string) =>
  useSuspenseQuery(params(contractUUID))
